import React from 'react'
import Collapsible from 'react-collapsible'

export default ({ ...props }) => (
  <Collapsible {...props} overflowWhenOpen='visible' />
)



// WEBPACK FOOTER //
// ./client/src/components/Collapsible.js